import { createStore, applyMiddleware } from "redux";
// import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import reducers from "./redux/reducers";
import { composeWithDevTools } from "redux-devtools-extension";

const middlewares = [];

// if (process.env.NODE_ENV === "development") {
//   middlewares.push(createLogger());
// }

// middlewares.push(actionsDependencies);
middlewares.push(thunk);

const store = composeWithDevTools(applyMiddleware(...middlewares))(createStore)(
  reducers
);

export default store;
